import React, { useEffect, useState } from "react";
import api from "../../../lib/api";
import { AdminButton, AdminInput, AdminCard } from "../AdminUI";
import { Save, Loader2, Plus, Trash2 } from "lucide-react";
import { toast } from "sonner";

const OpeningHoursTab = () => {
    const [entries, setEntries] = useState([]);
    const [saving, setSaving] = useState(false);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        api.get("/opening-hours").then((r) => {
            setEntries(r.data.entries || []);
            setLoading(false);
        });
    }, []);

    const update = (i, k, v) => {
        const next = [...entries];
        next[i] = { ...next[i], [k]: v };
        setEntries(next);
    };

    const add = () => setEntries([...entries, { day: "", hours: "", closed: false }]);
    const remove = (i) => setEntries(entries.filter((_, idx) => idx !== i));

    const save = async () => {
        setSaving(true);
        try {
            await api.put("/opening-hours", { entries });
            toast.success("Öffnungszeiten gespeichert");
        } catch {
            toast.error("Fehler beim Speichern");
        } finally {
            setSaving(false);
        }
    };

    if (loading) return <div className="flex justify-center py-10"><Loader2 className="w-6 h-6 animate-spin text-garden-green" /></div>;

    return (
        <div className="space-y-6 max-w-3xl" data-testid="opening-hours-tab">
            <AdminCard className="space-y-3">
                <h3 className="font-serif text-xl text-deep-green mb-3">Öffnungszeiten</h3>
                {entries.map((e, i) => (
                    <div key={i} className="grid grid-cols-12 gap-3 items-end" data-testid={`hour-row-${i}`}>
                        <div className="col-span-4">
                            <AdminInput label={i === 0 ? "Tag" : ""} value={e.day} onChange={(ev) => update(i, "day", ev.target.value)} placeholder="Montag" />
                        </div>
                        <div className="col-span-4">
                            <AdminInput label={i === 0 ? "Zeiten" : ""} value={e.hours} disabled={e.closed} onChange={(ev) => update(i, "hours", ev.target.value)} placeholder="13:00 - 19:00" />
                        </div>
                        <div className="col-span-3">
                            <label className="flex items-center gap-2 px-3 py-2.5 rounded-xl bg-cream-dark/60 cursor-pointer text-sm">
                                <input type="checkbox" checked={e.closed} onChange={(ev) => update(i, "closed", ev.target.checked)} />
                                Geschlossen
                            </label>
                        </div>
                        <div className="col-span-1">
                            <AdminButton variant="danger" onClick={() => remove(i)} data-testid={`hour-remove-${i}`}>
                                <Trash2 className="w-4 h-4" />
                            </AdminButton>
                        </div>
                    </div>
                ))}
                <AdminButton variant="secondary" onClick={add} data-testid="hour-add">
                    <Plus className="w-4 h-4" /> Tag hinzufügen
                </AdminButton>
            </AdminCard>

            <AdminButton onClick={save} loading={saving} data-testid="opening-hours-save">
                <Save className="w-4 h-4" /> Speichern
            </AdminButton>
        </div>
    );
};

export default OpeningHoursTab;
